﻿import React, { forwardRef, ReactNode, useImperativeHandle, useRef, useState } from 'react';

import 'components/GMetrixDialogAlert/gmetrix-dialog-alert.scss';

import { Modal } from 'react-bootstrap';

const GMetrixDialogAlert = forwardRef((props, forwardRef) => {

    const [showModal, setShowModal] = useState<boolean>(false);
    const [title, setTitle] = useState<ReactNode>(false);
    const [alertMessage, setAlertMessage] = useState<ReactNode>('');
    const resolveRef = useRef(null);
    const resolve = resolveRef?.current;
    const createAlert = (title: ReactNode, message: ReactNode) => new Promise(resolve => {

        resolveRef.current = resolve;
        setShowModal(true);
        setAlertMessage(message);
        setTitle(title);

    });

    const closeDialog = () => {

        setShowModal(false);
        resolve(null);

    };

    useImperativeHandle(forwardRef, () => ({
        alert: createAlert
    }), []);

    return (
        <Modal onHide={closeDialog} show={showModal}>
            {

                <Modal.Header closeButton>
                    <Modal.Title>
                        {title ? title : 'Notice'}
                    </Modal.Title>
                </Modal.Header>

            }
            <Modal.Body >
                <p className='text-center'>
                    {alertMessage}
                </p>
            </Modal.Body>
        </Modal>
    );

});
GMetrixDialogAlert.displayName = 'GMetrixDialogAlert';
export default GMetrixDialogAlert;